import React from "react";
import { Row, Col, Select, Button } from "antd";
import { Minimize2, Maximize2 } from "lucide-react";
import moment from "moment";

const CalendarHeader = ({ value, onChange, isMaximized, toggleMaximize }) => {
  const start = 0;
  const end = 12;
  const monthOptions = [];

  const current = value.clone();
  const localeData = value.localeData();
  const months = [];
  for (let i = 0; i < 12; i++) {
    current.month(i);
    months.push(localeData.months(current));
  }

  for (let index = start; index < end; index++) {
    monthOptions.push(
      <Select.Option key={`${index}`} value={index}>
        {months[index]}
      </Select.Option>
    );
  }

  const month = value.month();
  const year = value.year();
  const options = [];
  for (let i = year - 10; i < year + 10; i += 1) {
    options.push(
      <Select.Option key={i} value={i}>
        {i}
      </Select.Option>
    );
  }

  return (
    <div className="calendar-header">
      <Row gutter={8} align="middle" justify="space-between" style={{ marginRight: 16 }}>
        <Col>
          <div className="calendar-header-title">
            <h2>{moment(value).format("MMMM YYYY")}</h2>
          </div>
        </Col>
        <Col>
          <Row gutter={8}>
            <Col>
              <Select
                size="small"
                dropdownMatchSelectWidth={false}
                value={months[month]}
                onChange={(selectedMonth) => {
                  const newValue = value.clone().month(parseInt(selectedMonth, 10));
                  onChange(newValue);
                }}
                optionLabelProp="children"
                style={{ minWidth: 150 }}
              >
                {monthOptions}
              </Select>
            </Col>
            <Col>
              <Select
                size="small"
                dropdownMatchSelectWidth={false}
                value={String(year)}
                onChange={(selectedYear) => {
                  const newValue = value.clone().year(parseInt(selectedYear, 10));
                  onChange(newValue);
                }}
              >
                {options}
              </Select>
            </Col>
            <Col>
              <Button
                type="default"
                icon={isMaximized ? <Minimize2 size={14} /> : <Maximize2 size={14} />}
                onClick={toggleMaximize}
                style={{ marginLeft: "auto" }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default CalendarHeader;
